import store from 'chimera/all/store'

export default store
